import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { UilAngleDown, UilAngleUp } from '@iconscout/react-unicons';
import SelectableCssVariablesDropdown from './SelectableCssVariablesDropdown';

const CssEditorRow = ({ list, type, componentId, toggleOpen, isOpen }) => {
	const [elementHeight, setElementHeight] = React.useState('0px');
	const elementRef = React.useRef(null);
	const dispatch = useDispatch();

	React.useState(() => {
		let h = 'auto';
		if (!isOpen) {
			h = `${elementRef?.current?.scrollHeight}px`;
		}
		setElementHeight(h);
	}, [isOpen]);

	return (
		<Flex width={'100%'} border={'1px solid #E2E8F0'} borderRadius={'10px'} flexWrap={'wrap'}>
			<Text
				display={'flex'}
				justifyContent={'space-between'}
				_hover={{ cursor: 'pointer' }}
				onClick={toggleOpen}
				m={0}
				p={1}
				fontSize={'md'}
				fontWeight={'bold'}
				w={'100%'}
			>
				{type}
				{isOpen ? <UilAngleUp size={24} /> : <UilAngleDown size={24} />}
			</Text>

			<Box ref={elementRef} h={elementHeight} overflow={'hidden'} w={'100%'} display="flex" flexWrap="wrap">
				{isOpen
					? list.map((colorItem, idx) => (
							<SelectableCssVariablesDropdown
								key={`selectable-variables-${componentId}-${type}-${idx}`}
								{...colorItem}
								type={type}
							/>
						))
					: null}
			</Box>
		</Flex>
	);
};

export default CssEditorRow;
